module.exports = __webpack_public_path__ + "static/media/instructivosc7.d9d90613.png";